import React from 'react';
import emlaktv from './images/gridScreen.png';
import shop from "./images/shop.jpg"
import slaytmode from "./images/slytmode.png"
import yenihamdi from "./images/yenihamdiemlak.jpg"

const slogans = [
  {
    slogan: "Emlak Vitrini sizi Zahmetten Kurtarıyor!",
    description: "Artık camekâna elle ilan yazmak yok! Sizi zahmetten ve kötü görüntüden kurtarıyoruz. İlanlarınızı tek seferde platforma girin, sistem otomatik olarak vitrininize taşısın. Vakit kazanın, görünürlük kazanın. Hem kendi adınızla kişisel bir online dükkânınız olsun, hem de vitrin ekranınız modern ve şık bir görünüme kavuşsun.",
    image:shop
  },
  {
    slogan: "İlanlarınız Büyük Ekranda Daha Etkileyici.",
    description: "EmlakVitriniTV Android televizyon uygulaması ile ilanlarınız daha fazla görünürlük kazanır. İlanınızı, emlakvitrini.net'in size sağladığı kişisel online sitenize eklersiniz, anında Android TV’nizin ekranına yansır.Müşterileriniz ekrandan karekodu okutarak online sitenizden ilan detaylarına ulaşabilirler !",
    image:emlaktv
  },
  {
    slogan: "Sadece İnternette Değil, TV’de de Görün!",
    description: "Geleneksel müşteri kitleniz hala ekran başında. EmlakVitrini TV ile hem dijital platformda hem de fiziksel vitrinde aynı anda var olun. Etki alanınızı genişletin.",
    image:slaytmode
  },
  {
    slogan: "Kendi TV Vitrininizi Oluşturun – Basit, Hızlı, Profesyonel.",
    description: "Üyelik oluşturun, ilanlarınızı yükleyin, hepsi bu kadar! Otomatik yayın sistemi ile kurumsal vitrininizi yönetmek çok kolay. Teknik bilgi gerekmez, arayüz oldukça sezgiseldir.",
    image:shop
  },
  {
    slogan: "Tek Seferde Hem Online Dükkanınızda Hem Vitrininizde!",
    description: "Aynı ilanı iki kez girmenize gerek kalmaz. Tüm ilanlarınız hem emlakvitrini.net’te Aynı anda isminize özel web sitenizde , hem de vitrin ekranınızda senkronize şekilde yayınlanır. Zaman kazandırır, hata payını azaltır.",
    image:yenihamdi
  },
  {
    slogan: "Marka Değerinizi Ekrana Taşıyın.",
    description: "Sıradan tanıtımlardan sıyrılın. Kurumsal renginize uygun, kaliteli slaytlarla profesyonel bir duruş sergileyin. Vitrin ekranlarınız, artık satış temsilciniz gibi çalışacak.",
    image:shop
  }
];

const sloganColors = [
  "#4F75FF", "#FF6F61", "#00C9A7", "#F7971E", "#9D50BB", "#1DE9B6"
];

const SloganGrid = () => {
  return (
    <div style={{ backgroundColor: '#f5f5f5', padding: '10px 20px' }}>
      <style>{`
        @media (max-width: 768px) {
          .slogan-block {
            grid-template-columns: 1fr !important;
            padding: 15px !important;
            gap: 20px !important;
          }
          .slogan-text h1 {
            font-size: 22px !important;
            text-align: center !important;
          }
          .slogan-text p {
            font-size: 15px !important;
            text-align: left !important;
          }
        }
      `}</style>

      {slogans.map((item, index) => {
        const isEven = index % 2 === 0;

        const sloganStyle = {
          color: sloganColors[index % sloganColors.length],
          fontSize: '32px',
          fontWeight: '700',
          textAlign: 'center',
          marginBottom: '20px',
          lineHeight: 1.3
        };

        const descriptionStyle = {
          color: '#444',
          fontSize: '18px',
          lineHeight: 1.7,
          textAlign: 'left'
        };

        return (
          <div
            key={index}
            className="slogan-block"
            style={{
              backgroundColor: 'white',
              borderRadius: '16px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              padding: '20px',
              width: '90%',
              maxWidth: '1100px',
              margin: '10px auto',
              display: 'grid',
              gridTemplateColumns: isEven ? '2fr 2fr' : '2fr 2fr',
              gap: '40px',
              alignItems: 'center'
            }}
          >
            {isEven ? (
              <>
                <div className="slogan-text">
                  <h1 style={sloganStyle}>{item.slogan}</h1>
                  <p style={descriptionStyle}>{item.description}</p>
                </div>
                <img
                  src={item.image}
                  alt="Emlak Vitrini TV"
                  style={{
                    width: '100%',
                    borderRadius: '6px',
                    objectFit: 'cover',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                  }}
                />
              </>
            ) : (
              <>
                <img
                  src={item.image}
                  alt="Emlak Vitrini TV"
                  style={{
                    width: '100%',
                    borderRadius: '6px',
                    objectFit: 'cover',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                  }}
                />
                <div className="slogan-text">
                  <h1 style={sloganStyle}>{item.slogan}</h1>
                  <p style={descriptionStyle}>{item.description}</p>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SloganGrid;
